import React from 'react';
import { getWeatherIcon } from '../utils/uiService';

/**
 * Forecast Component
 * Displays 3-day weather forecast
 */
const Forecast = ({ forecast, unit }) => {
  if (!forecast || forecast.length === 0) {
    return null;
  }

  const convertTemp = (temp) => {
    return unit === 'F' ? Math.round((temp * 9/5) + 32) : temp;
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">3-Day Forecast</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {forecast.map((day, index) => (
          <div
            key={index}
            className="bg-white/10 backdrop-blur-md rounded-xl p-6"
          >
            <p className="font-semibold mb-4">{day.date}</p>
            <div className="flex items-center justify-between mb-4">
              <span className="text-4xl" aria-label={`Weather: ${day.condition}`}>
                {getWeatherIcon(day.condition)}
              </span>
              <div className="text-right">
                <p className="text-3xl font-bold">{convertTemp(day.maxTemp)}°</p>
                <p className="text-gray-300">{convertTemp(day.minTemp)}°</p>
              </div>
            </div>
            <div className="space-y-2 text-sm text-gray-300">
              <p>Humidity: {day.humidity}%</p>
              <p>Wind: {day.windSpeed} km/h {day.windDirection && `(${day.windDirection})`}</p>
              <p>Chance of Rain: {day.chanceOfRain}%</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Forecast;
